import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { uniqBy, property, get, isFunction, groupBy } from '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var getFilterLabel = function getFilterLabel(column, value) {
  return column.filterLabels ? column.filterLabels[value] || value : value;
};
var getFilterLabels = function getFilterLabels(column, rows) {
  return uniqBy(rows, property(column.searchBy || column.property)).map(function (row) {
    var value = get(row, column.searchBy || column.property);
    if (value === undefined) return {};
    var rowColumnValue = String(get(row, column.searchBy || column.property));

    if (isFunction(column.valueTransformation)) {
      var nextValue = column.valueTransformation(rowColumnValue);
      return {
        id: nextValue,
        label: nextValue
      };
    }

    var label = getFilterLabel(column, rowColumnValue);
    return {
      id: rowColumnValue || label,
      label: label
    };
  }).filter(function (row) {
    return row.id;
  }).filter(function (row) {
    if (row.id.startsWith) return !row.id.startsWith('grouped-by');
    return true;
  });
};
var getFilterLabelsGroup = function getFilterLabelsGroup(column, rows) {
  var flat = [];
  rows.forEach(function (r) {
    if (r.children) {
      flat = [].concat(_toConsumableArray(flat), _toConsumableArray(r.children));
    }
  });
  return getFilterLabels(column, flat);
};
function getFilterValue(filter, column) {
  var value = filter.value;
  if (!column) return value;
  var filterOptions = column.filterOptions,
      filterLabels = column.filterLabels;

  if (filterOptions) {
    var foundOption = column.filterOptions.filter(function (option) {
      return option.id === value;
    })[0];
    if (foundOption) return foundOption.label;
    return value;
  }

  if (filterLabels) {
    return filterLabels[value];
  }

  return value;
}
function buildFilterArray(newFilter, filters) {
  // if (newFilter.type && newFilter.type === 'date') return [...filters.slice(1), newFilter]
  return uniqBy([].concat(_toConsumableArray(filters), [newFilter]), function (v) {
    return [v.group, v.value].join();
  });
}
var groupFilters = function groupFilters(filters) {
  return filters.filter(function (filter) {
    return !filter.fixed;
  });
};

function parseFilterToRule(filter) {
  return _objectSpread(_objectSpread({}, filter), {}, {
    value: filter.filterParams || filter.value,
    field: filter.group
  });
}

function parseFiltersToQuery(filters) {
  var groupedFilters = groupBy(groupFilters(filters), function (filter) {
    return filter.group;
  });
  return Object.keys(groupedFilters).reduce(function (queryResult, field) {
    var filter = groupedFilters[field];

    if (Array.isArray(filter) && filter.length > 1) {
      // create query group with 'OR' condition
      queryResult.rules.push({
        condition: 'OR',
        rules: filter.map(parseFilterToRule)
      });
    } else {
      queryResult.rules.push(parseFilterToRule(filter[0]));
    }

    return queryResult;
  }, {
    condition: 'AND',
    rules: []
  });
}

export { buildFilterArray, getFilterLabel, getFilterLabels, getFilterLabelsGroup, getFilterValue, groupFilters, parseFiltersToQuery };
//# sourceMappingURL=helper.js.map
